import every from 'lodash/every';
import isEqual from 'lodash/isEqual';
import isEqualWith from 'lodash/isEqualWith';

const customizer: (val1: any, val2: any) => boolean = (val1: any, val2: any) => {
  if (typeof val1 === 'object' && val1 !== null) {
    let keys = Object.keys(val1);
    if (typeof val2 === 'object' && val2 !== null) {
      keys = keys.concat(Object.keys(val2));
    }

    return every(keys, (key) => {
      if (val2 === undefined || val2 === null) {
        return false;
      }

      if (val1[key] === undefined && val2[key] === undefined) {
        return true;
      }

      if (typeof val1[key] === 'object') {
        return isEqualWith(val1[key], val2[key], customizer);
      }

      return isEqual(val1[key], val2[key]);
    });
  }

  return isEqual(val1, val2);
};

// Deep compare similar to lodash's isEqual except a missing property is considered the
// the same as a property with the value set to undefined.
export const isEqualLooseUndefined = (val1: any, val2: any) => {
  return isEqualWith(val1, val2, customizer);
};
